export { default } from './MasterDetailLayout';
